import { AppRoute } from 'src/core/AppRoute';

/* Account Route */
export const ROUTE_ACCOUNT = new AppRoute('/account', 'account');

/* Data */
export const ROUTE_ACCOUNT_DATA = ROUTE_ACCOUNT.sub('data', 'account_data');
export const ROUTE_ACCOUNT_DATA_MAIN = ROUTE_ACCOUNT_DATA.sub('main', 'account_data_main');
export const ROUTE_ACCOUNT_DATA_DOCUMENTS = ROUTE_ACCOUNT_DATA.sub('documents', 'account_data_documents');
export const ROUTE_ACCOUNT_DATA_ADDRESSES = ROUTE_ACCOUNT_DATA.sub('addresses', 'account_data_addresses');
export const ROUTE_ACCOUNT_DATA_FEEDBACK = ROUTE_ACCOUNT_DATA.sub('feedback', 'account_data_feedback');
export const ROUTE_ACCOUNT_DATA_PREMIUMPROGRAM = ROUTE_ACCOUNT_DATA.sub(
    'premium-program',
    'account_data_premium_program'
);

export const GROUP_ACCOUNT_DATA = [
    ROUTE_ACCOUNT_DATA_MAIN,
    ROUTE_ACCOUNT_DATA_DOCUMENTS,
    ROUTE_ACCOUNT_DATA_ADDRESSES,
    ROUTE_ACCOUNT_DATA_FEEDBACK,
    ROUTE_ACCOUNT_DATA_PREMIUMPROGRAM,
];

/* Orders */
export const ROUTE_ACCOUNT_ORDERS = ROUTE_ACCOUNT.sub('orders', 'account_orders');

/* Offers */
export const ROUTE_ACCOUNT_OFFERS = ROUTE_ACCOUNT_ORDERS.sub('offers', 'account_offers', {
    accessPrivilege: ['office_profi'],
});

/* Credits */
export const ROUTE_ACCOUNT_CREDITS = ROUTE_ACCOUNT.sub('credits', 'account_credits');

/* Landingpages */
export const ROUTE_ACCOUNT_LANDINGPAGES = ROUTE_ACCOUNT.sub('landingpages', 'account_landingpages', {
    accessPrivilege: ['partner', 'licensee', 'mlg', 'landing_page', 'office_profi'],
});
export const ROUTE_ACCOUNT_LANDINGPAGES_OWNER = ROUTE_ACCOUNT_LANDINGPAGES.sub(':owner', 'account_landingpages_owner');
export const ROUTE_ACCOUNT_LANDINGPAGE_DETAILS = ROUTE_ACCOUNT_LANDINGPAGES_OWNER.sub(
    ':lp',
    'account_landingpage_details'
);
export const ROUTE_ACCOUNT_LANDINGPAGE_DETAILS_TABS = ROUTE_ACCOUNT_LANDINGPAGE_DETAILS.sub(
    ':tab',
    'account_landingpage_details_tabs'
);

/* Downloads */
export const ROUTE_ACCOUNT_DOWNLOAD = ROUTE_ACCOUNT.sub('downloads', 'account_downloads');

export const ROUTE_ACCOUNT_DOWNLOAD_INFO_TOPIC = ROUTE_ACCOUNT_DOWNLOAD.sub(':topic', 'account_downloads_info_topic');
export const ROUTE_ACCOUNT_DOWNLOAD_INVOICE = ROUTE_ACCOUNT_DOWNLOAD.sub('invoices', 'account_downloads_invoice');
export const ROUTE_ACCOUNT_DOWNLOAD_COMMISSION = ROUTE_ACCOUNT_DOWNLOAD.sub(
    'commission-invoices',
    'account_downloads_commission'
);

/* Device Service */
export const ROUTE_ACCOUNT_SERVICE = ROUTE_ACCOUNT.sub('service', 'account_service');
export const ROUTE_ACCOUNT_SERVICE_DEVICE = ROUTE_ACCOUNT_SERVICE.sub('devices', 'account_service_device');

/* Calendar */
export const ROUTE_ACCOUNT_CALENDAR = ROUTE_ACCOUNT.sub('calendar', 'account_calendar', {
    accessPrivilege: ['licensee', 'office_profi'],
});

/* Commission */
export const ROUTE_ACCOUNT_COMMISSION = ROUTE_ACCOUNT.sub('commission', 'account_commission', {
    accessPrivilege: ['licensee', 'office_profi', 'partner', 'mlg', 'referral_partner'],
});

export const ROUTE_ACCOUNT_COMMISSION_STATS = ROUTE_ACCOUNT_COMMISSION.sub('stats', 'account_commission_stats');

export const ROUTE_ACCOUNT_COMMISSION_CHART = ROUTE_ACCOUNT_COMMISSION.sub('chart', 'account_commission_chart');

export const GROUP_ACCOUNT_COMMISSION = [
    ROUTE_ACCOUNT_COMMISSION,
    ROUTE_ACCOUNT_COMMISSION_STATS,
    ROUTE_ACCOUNT_COMMISSION_CHART,
];

/* Organization */
export const ROUTE_ACCOUNT_ORGANIZATION = ROUTE_ACCOUNT.sub('organization', 'account_organization', {
    accessPrivilege: ['licensee', 'office_profi', 'partner', 'mlg'],
});

export const ROUTE_ACCOUNT_ORGANIZATION_OVERVIEW = ROUTE_ACCOUNT_ORGANIZATION.sub(
    'overview',
    'account_organization_overview',
    {
        accessPrivilege: ['licensee', 'office_profi', 'partner', 'mlg'],
    }
);

export const ROUTE_ACCOUNT_ORGANIZATION_CUSTOMERS = ROUTE_ACCOUNT_ORGANIZATION.sub(
    'customers',
    'account_organization_customers',
    {
        accessPrivilege: ['licensee', 'office_profi', 'partner', 'mlg'],
    }
);
export const ROUTE_ACCOUNT_ORGANIZATION_SIS_PARTNERS = ROUTE_ACCOUNT_ORGANIZATION.sub(
    'sis-partners',
    'account_organization_sis_partners',
    {
        accessPrivilege: 'partner',
    }
);

export const ROUTE_ACCOUNT_ORGANIZATION_OFFICE_PROFIS = ROUTE_ACCOUNT_ORGANIZATION.sub(
    'office_profis',
    'account_organization_office_profis',
    {
        accessPrivilege: 'partner',
    }
);

export const ROUTE_ACCOUNT_ORGANIZATION_LICENSORS = ROUTE_ACCOUNT_ORGANIZATION.sub(
    'licensors',
    'account_organization_licensors',
    {
        accessPrivilege: 'mlg',
    }
);
export const ROUTE_ACCOUNT_ORGANIZATION_PLACEMENTS = ROUTE_ACCOUNT_ORGANIZATION.sub(
    'placements',
    'account_organization_placements'
);

/* Mitarbeiterchip */
export const ROUTE_ACCOUNT_CHIP = ROUTE_ACCOUNT.sub('chip', 'account_chip', {
    accessPrivilege: ['vending_admin', 'vending_customer', 'vending_viewer'],
});
export const ROUTE_ACCOUNT_CHIP_VERWALTUNG = ROUTE_ACCOUNT_CHIP.sub('verwaltung', 'account_chip_verwaltung', {
    accessPrivilege: ['vending_admin'],
});

/* Success List */
export const ROUTE_ACCOUNT_SUCCESS_LIST = ROUTE_ACCOUNT.sub('success-list', 'account_success_list', {
    accessPrivilege: ['office_profi', 'partner', 'mlg'],
});

export const ROUTE_ACCOUNT_SUCCESS_LIST_OVERVIEW = ROUTE_ACCOUNT_SUCCESS_LIST.sub(
    'overview',
    'account_success_list_overview'
);

export const ROUTE_ACCOUNT_SUCCESS_LIST_TOPICS_GROUP = ROUTE_ACCOUNT_SUCCESS_LIST.sub(
    ':successListTopic',
    'account_success_list_topics'
);

// maybe deprecated?
export const ROUTE_ACCOUNT_ACADEMY = ROUTE_ACCOUNT.sub('academy', 'account_academy', { accessPrivilege: 'partner' });

/* Videos */
export const ROUTE_ACCOUNT_VIDEO = ROUTE_ACCOUNT.sub('video', 'account_video');

export const ROUTE_VIDEO_TOPICS_GROUP = ROUTE_ACCOUNT_VIDEO.sub(':videoTopic', 'video_topics');

/* Account Routes Group */
export const GROUP_ACCOUNT = [
    ROUTE_ACCOUNT_DATA,
    ROUTE_ACCOUNT_ORDERS,
    ROUTE_ACCOUNT_OFFERS,
    ROUTE_ACCOUNT_CREDITS,
    ROUTE_ACCOUNT_DOWNLOAD,
    ROUTE_ACCOUNT_SERVICE,
    ROUTE_ACCOUNT_SUCCESS_LIST,
    ROUTE_ACCOUNT_VIDEO,
    ROUTE_ACCOUNT_CALENDAR,
    [
        ROUTE_ACCOUNT_ORGANIZATION,
        ROUTE_ACCOUNT_ORGANIZATION_OVERVIEW,
        ROUTE_ACCOUNT_ORGANIZATION_CUSTOMERS,
        ROUTE_ACCOUNT_ORGANIZATION_SIS_PARTNERS,
        ROUTE_ACCOUNT_ORGANIZATION_OFFICE_PROFIS,
        ROUTE_ACCOUNT_ORGANIZATION_LICENSORS,
        ROUTE_ACCOUNT_ORGANIZATION_PLACEMENTS,
    ],
    ROUTE_ACCOUNT_COMMISSION,
    ROUTE_ACCOUNT_LANDINGPAGES,
    ROUTE_ACCOUNT_CHIP,
];
